import React from "react";

import "./WizardMobileTitle.scss";

export const WizardMobileTitle = ({ children }) => (
  <div className={"wizard-mobile-title"}>{children}</div>
);
